import { dialogModalHandler } from 'src/utils/helpers';
import { IUser } from 'src/utils/interfaces/user';
import { useLocalization } from 'src/utils/useLocalization';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './styles.scss';

export interface IChild {
    name: string;
    path?: string;
    icon?: string;
    handler?: Function;
}

interface IArgs {
    submenus?: Array<IChild>;
    dropdown: boolean;
    handlerChange?: Function;
    handlerItemChange?: Function;
    showSelected?: boolean;
    showSelectedIcon?: boolean;
    defaultSelected?: string;
    children?: any;
    right?: string;
    ref?: any;
    isDealership?: boolean;
    shouldUseModal?: boolean;
}

const Dropdown = ({
    submenus,
    dropdown,
    handlerChange,
    handlerItemChange,
    defaultSelected,
    showSelectedIcon,
    children,
    right,
    isDealership = false,
    shouldUseModal = true,
}: IArgs) => {
    const { t } = useTranslation();
    const { labelText } = useLocalization();
    const ref: any = useRef(null);
    const { dialogModal } = useSelector((state: IUser) => {
        return state;
    });
    const dispatch = useDispatch();
    const onMouseEnter = () => {
        // eslint-disable-next-line no-magic-numbers
        window.innerWidth > 960 && handlerChange && handlerChange(true);
    };

    const onMouseLeave = () => {
        // eslint-disable-next-line no-magic-numbers
        window.innerWidth > 960 && handlerChange && handlerChange(false);
    };
    const [selected, setSelected] = useState<string>(defaultSelected || '');
    useEffect(() => {
        const handler = (event: any) => {
            if (
                dropdown &&
                ref.current &&
                !ref.current.contains(event.target)
            ) {
                if (handlerChange) handlerChange(false);
            }
        };
        document.addEventListener('mousedown', handler);
        document.addEventListener('touchstart', handler);
        return () => {
            // Cleanup the event listener
            document.removeEventListener('mousedown', handler);
            document.removeEventListener('touchstart', handler);
        };
    }, [dropdown]);
    useEffect(() => {
        setSelected(defaultSelected as string);
    }, [defaultSelected]);
    if (children)
        return (
            <ul
                className={`dropdown ${dropdown ? 'show' : ''}`}
                ref={ref}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                {children}
            </ul>
        );
    return (
        <ul
            className={`dropdown ${dropdown ? 'show' : ''} ${
                isDealership ? 'dealership_large' : ''
            }`}
            style={{ right: `${right ? right : '0'}px` }}
            ref={ref}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {submenus && submenus.length ? (
                submenus.map((submenu, index) => (
                    <li key={index} className='menu-items'>
                        {submenu.name && submenu.path ? (
                            handlerChange ? (
                                <a
                                    href={submenu.path}
                                    onClick={(event) => {
                                        if (
                                            dialogModal.isModalActive &&
                                            selected !== submenu.name &&
                                            shouldUseModal
                                        ) {
                                            event.preventDefault();
                                            dialogModalHandler(
                                                event,
                                                dispatch,
                                                dialogModal,
                                            );
                                        } else if (submenu.handler) {
                                            submenu.handler(submenu.name);
                                            setSelected(submenu.name);
                                        } else if (handlerItemChange) {
                                            handlerItemChange(submenu.name);
                                            setSelected(submenu.name);
                                        }
                                    }}
                                    className={`${
                                        submenu.name.startsWith(selected)
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    {t(submenu.name)}
                                    {showSelectedIcon &&
                                        submenu.name.startsWith(selected) && (
                                            <i
                                                className={
                                                    'c-icon c-icon--[semantic-checkmark] u-ml-small'
                                                }
                                                aria-hidden='true'
                                                role='img'
                                            />
                                        )}
                                </a>
                            ) : (
                                <a href={submenu.path}>{t(submenu.name)}</a>
                            )
                        ) : (
                            <span>{t(submenu.name)}</span>
                        )}
                    </li>
                ))
            ) : (
                <li>
                    <span>{labelText.LABEL_TEXT_DASH_NORESULTS}</span>
                </li>
            )}
        </ul>
    );
};

export default Dropdown;
